"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MixinNativeCosmosWalletInfo = MixinNativeCosmosWalletInfo;
exports.MixinNativeCosmosWallet = MixinNativeCosmosWallet;
const core = __importStar(require("@shapeshiftoss/hdwallet-core"));
const bech32 = __importStar(require("bech32"));
const crypto_js_1 = __importDefault(require("crypto-js"));
const p_lazy_1 = __importDefault(require("p-lazy"));
const Isolation = __importStar(require("./crypto/isolation"));
const util = __importStar(require("./util"));
const ATOM_CHAIN = "cosmoshub-4";
const protoTxBuilder = p_lazy_1.default.from(() => Promise.resolve().then(() => __importStar(require("@shapeshiftoss/proto-tx-builder"))));
function MixinNativeCosmosWalletInfo(Base) {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return class MixinNativeCosmosWalletInfo extends Base {
        constructor() {
            super(...arguments);
            this._supportsCosmosInfo = true;
        }
        cosmosSupportsNetwork() {
            return __awaiter(this, void 0, void 0, function* () {
                return true;
            });
        }
        cosmosSupportsSecureTransfer() {
            return __awaiter(this, void 0, void 0, function* () {
                return false;
            });
        }
        cosmosSupportsNativeShapeShift() {
            return false;
        }
        cosmosGetAccountPaths(msg) {
            const slip44 = core.slip44ByCoin("Atom");
            return [
                {
                    addressNList: [0x80000000 + 44, 0x80000000 + slip44, 0x80000000 + msg.accountIdx, 0, 0],
                },
            ];
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        cosmosNextAccountPath(msg) {
            // Only support one account for now (like portis).
            return undefined;
        }
    };
}
function MixinNativeCosmosWallet(Base) {
    var _MixinNativeCosmosWallet_masterKey, _a;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return _a = class MixinNativeCosmosWallet extends Base {
            constructor() {
                super(...arguments);
                this._supportsCosmos = true;
                _MixinNativeCosmosWallet_masterKey.set(this, void 0);
            }
            cosmosInitializeWallet(masterKey) {
                return __awaiter(this, void 0, void 0, function* () {
                    __classPrivateFieldSet(this, _MixinNativeCosmosWallet_masterKey, masterKey, "f");
                });
            }
            cosmosWipe() {
                __classPrivateFieldSet(this, _MixinNativeCosmosWallet_masterKey, undefined, "f");
            }
            cosmosBech32ify(address, prefix) {
                const words = bech32.toWords(address);
                return bech32.encode(prefix, words);
            }
            createCosmosAddress(publicKey) {
                const message = crypto_js_1.default.SHA256(crypto_js_1.default.enc.Hex.parse(publicKey));
                const hash = crypto_js_1.default.RIPEMD160(message).toString();
                const address = Buffer.from(hash, `hex`);
                return this.cosmosBech32ify(address, `cosmos`);
            }
            cosmosGetAddress(msg) {
                return __awaiter(this, void 0, void 0, function* () {
                    return this.needsMnemonic(!!__classPrivateFieldGet(this, _MixinNativeCosmosWallet_masterKey, "f"), () => __awaiter(this, void 0, void 0, function* () {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const keyPair = yield util.getKeyPair(__classPrivateFieldGet(this, _MixinNativeCosmosWallet_masterKey, "f"), msg.addressNList, "cosmos");
                        return this.createCosmosAddress(keyPair.publicKey.toString("hex"));
                    }));
                });
            }
            cosmosSignTx(msg) {
                return __awaiter(this, void 0, void 0, function* () {
                    return this.needsMnemonic(!!__classPrivateFieldGet(this, _MixinNativeCosmosWallet_masterKey, "f"), () => __awaiter(this, void 0, void 0, function* () {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const keyPair = yield util.getKeyPair(__classPrivateFieldGet(this, _MixinNativeCosmosWallet_masterKey, "f"), msg.addressNList, "cosmos");
                        const adapter = yield Isolation.Adapters.CosmosDirect.create(keyPair.node, "cosmos");
                        const signerData = {
                            sequence: Number(msg.sequence),
                            accountNumber: Number(msg.account_number),
                            chainId: ATOM_CHAIN,
                        };
                        return (yield protoTxBuilder).sign(adapter.address, msg.tx, adapter, signerData, "cosmos");
                    }));
                });
            }
        },
        _MixinNativeCosmosWallet_masterKey = new WeakMap(),
        _a;
}
//# sourceMappingURL=cosmos.js.map